export default __webpack_public_path__ + "b8e5cc029245a7523ffeb234e5ded37c.jpg";